module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.iconComponent, {
    tag: "component",
    staticClass: "inline-block fill-current",
    staticStyle: {
      "height": "1em",
      "width": "1em"
    },
    attrs: {
      "role": "img"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1075d8b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/BaseIcon.vue
// module id = 678
// module chunks = 0